import { motion } from "framer-motion";

/**
 * Masked line-by-line / word-by-word reveal. Each "line" is a string.
 * Pass linesMode='words' for staggered words within a single string.
 */
export const RevealLines = ({ lines = [], className = "", stagger = 0.08, delay = 0 }) => (
    <span className={className}>
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden">
                <motion.span
                    className="block"
                    initial={{ y: "115%" }}
                    animate={{ y: "0%" }}
                    transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1], delay: delay + i * stagger }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);

export const RevealWords = ({
    text = "",
    className = "",
    wordClass = "",
    stagger = 0.045,
    delay = 0,
    whileInView = false,
}) => {
    const words = text.split(" ");
    const activate = whileInView ? { whileInView: { y: "0%" } } : { animate: { y: "0%" } };
    return (
        <span className={className}>
            {words.map((w, i) => (
                <span key={i} className="inline-block overflow-hidden align-baseline pr-[0.22em]">
                    <motion.span
                        className={`inline-block ${wordClass}`}
                        initial={{ y: "115%" }}
                        {...activate}
                        viewport={whileInView ? { once: true, margin: "-60px" } : undefined}
                        transition={{ duration: 0.85, ease: [0.19, 1, 0.22, 1], delay: delay + i * stagger }}
                    >
                        {w}
                    </motion.span>
                </span>
            ))}
        </span>
    );
};

/** Scroll-triggered fade + rise for section chunks */
export const FadeUp = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.19, 1, 0.22, 1], delay }}
        className={className}
    >
        {children}
    </motion.div>
);
